module.exports = __webpack_public_path__ + "img/endoscope.8da07e43.svg";